<template>

  <div id="nav">
    <div id="nav-header">
      <router-link to="/">
        <img id="logo" src="../../assets/logo.svg">
      </router-link>
      <div>
        <template v-if="!is_mobile">
          <router-link to="/about">
            <button class="header-btn">About</button>
          </router-link>
          <router-link to="/faq">
            <button class="header-btn">FAQ</button>
          </router-link>
          <router-link to="/pricing">
            <button class="header-btn">Pricing</button>
          </router-link>
          <router-link to="/signup">
            <button id="login-btn">Sign Up</button>
          </router-link>
        </template>
        <button v-else @click="show_mobile_menu = true" id="open-mobile-menu-btn"></button>
      </div>
    </div>

    <div id="mobile-menu" :class="{ show: show_mobile_menu }">
      <button @click="show_mobile_menu = false" id="close-mobile-menu-btn"></button>
      <router-link to="/">
        <img id="mobile-menu-logo" src="../../assets/logo.svg">
      </router-link>
      <ul>
        <!-- <router-link to="/" v-if="page !== 'home'">
          <li>🏠 Home</li>
        </router-link> -->
        <router-link to="/about">
          <li>👋 About Us</li>
        </router-link>
        <router-link to="/faq">
          <li>⁉️ FAQ</li>
        </router-link>
        <router-link to="/pricing">
          <li>💵 Pricing</li>
        </router-link>
        <!-- <li>💬 Blog</li> -->
        <router-link to="/privacy">
          <li>🔒 Privacy</li>
        </router-link>
        <router-link to="/signup">
          <li>🔑 Sign Up</li>
        </router-link>
      </ul>
    </div>

  </div>

</template>

<script>

import { isMobile, isMobileOnly } from 'mobile-device-detect';

export default {
  name: 'LandingHeader',
  props: { page: String },
  data: function () {
    return {
      show_mobile_menu: false
    }
  },
  computed: {
    is_mobile() {
      return isMobileOnly;
    }
  },
  methods: {
    openMobileMenu() {
      console.log('open mobile menu');
    },
  }

}
</script>

<style scoped lang="scss">

#nav{
  position: absolute;
    top: 30px;
  width: 100%;
  margin-top: 15px;
  & > #nav-header{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  #logo{
    width: 180px;
  }
  #login-btn{
    padding: 6px 12px;
    margin-left: 30px;
    font-size: 15px;
    font-weight: 600;
    color: rgb(245,245,245);
    border-style: solid;
    border-width: 2px;
    border-color: rgb(150,150,150);
    border-radius: 4px;
    background-color: transparent;
    transition: all 0.3s ease;
    cursor: pointer;
    &:hover{
      border-color: white;
      color: white;
    }
  }
  .header-btn{
    padding: 6px 12px;
    font-size: 15px;
    font-weight: 600;
    color: rgb(225, 225, 225);
    border: none;
    margin-right: 10px;
    background-color: transparent;
    transition: all 0.1s ease;
    cursor: pointer;
    &:hover{
      border-color: white;
      color: white;
    }
    &:focus{
      outline: 0;
    }
  }

  #open-mobile-menu-btn{
    height: 34px;
    width: 34px;
    background-size: 34px;
    background-color: transparent;
    background-image: url("../../assets/icons/mobile-menu.svg");
    background-repeat: no-repeat;
    border: none;
  }

}


#mobile-menu{
  position: fixed;
    top: 0;
    left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: #0F1F28;
  transform: translateY(-100%);
  transition: all 0.2s ease;
  &.show{
    transform: translateY(0%);
  }
  ul{
    margin-top: 150px;
    margin-left: 0%;
    li{
      font-size: 23px;
      font-weight: 500;
      height: 75px;
      color: white;
      list-style: none;
    }
  }
  #mobile-menu-logo{
    position: fixed;
      top: 37px;
      left: 26px;
    width: 180px;
  }
  #close-mobile-menu-btn{
    position: fixed;
      top: 30px;
      right: 23px;
    height: 36px;
    width: 36px;
    background-size: 36px;
    background-color: transparent;
    background-image: url("../../assets/icons/close-mobile-menu.svg");
    background-repeat: no-repeat;
    border: none;
  }
}

/* Mobile Styles */
@media only screen
and (min-device-width : 320px)
and (max-device-width : 480px) {
  #nav{
    top: 15px;
  }
  .header-btn{
    display: none;
  }
}


</style>
